import { useState } from "react";
/// @ts-ignore
import { FileManager } from "@cubone/react-file-manager";
import "@cubone/react-file-manager/dist/style.css";
import { useArquivoConteudoBaixar, useArquivoConteudoCriarPasta, useArquivoConteudoDeletar, useArquivoConteudoListarDiretorio, useArquivoConteudoRenomear } from "@/Services/Domain/Servico/ArquivoConteudoService";
import ArquivoConteudo from "@/Models/Domain/Servico/ArquivoConteudo";
export default function FileManagerElement({onChange}:{
    onChange:(arquivo:ArquivoConteudo) => void
}) {
    const [caminho, setCaminho] = useState("/");
    
    const {
        data : files,
        isLoading,
        isFetching,
        refetch
    } = useArquivoConteudoListarDiretorio({
        caminho : caminho,
        enabled : true
    });

    const {
        isPending : isPendingCriarPasta,
        mutate
    } = useArquivoConteudoCriarPasta({
        onSuccess() {
            refetch();
        }
    });

    const {
        isPending : isPendingDeletar,
        mutate : mutateDeletar
    } = useArquivoConteudoDeletar({
        onSuccess() {
            refetch();
        }
    });

    const {
        isPending : isPendingRenomear,
        mutate : mutateRenomear
    } = useArquivoConteudoRenomear({
        onSuccess() {
            refetch();
        }
    });

    const {
        isPending : isPendingBaixar,
        mutate : mutateBaixar
    } = useArquivoConteudoBaixar({
        onSuccess(response) {
            console.log("Arquivo Baixado: ", response.data);

            const elementoA = document.createElement("a");
            document.body.appendChild(elementoA);
            elementoA.id = "linkDownloadArquivo";
            elementoA.style.display = "none";

            const contentDisposition = Object.fromEntries(
                ((response.headers["content-disposition"] as string) ?? (response.headers["Content-Disposition"] as string))
                    .split(";")
                    .map((grupo) => [grupo.split("=")[0]?.trim(), grupo.split("=")[1]?.trim()])
            );
            const url = window.URL.createObjectURL(response.data);

            elementoA.href = url;
            elementoA.download = contentDisposition["filename"];
            elementoA.click();

            document.body.removeChild(elementoA);
        },
    });

    const carregando = isLoading || isFetching || isPendingCriarPasta || isPendingDeletar || isPendingRenomear || isPendingBaixar;

    return <div className="ck-reset_all-excluded" style={{ minWidth : "60vw", maxWidth : "80vw" }}>
        <FileManager 
            files={files}
            initialPath={caminho}
            language="pt-Br"
            isLoading={carregando}
            enableFilePreview={false}
            collapsibleNav={false}
            filePreviewPath={process.env.NODE_ENV === "development" ? 'https://localhost:7123/api/domain/servico/ArquivoConteudo' : `${window.location.origin}/api/api/domain/servico/ArquivoConteudo`}
            fileUploadConfig={{ 
                method: "POST",
                headers: {

                },
                url: process.env.NODE_ENV === "development" ? 'https://localhost:7123/api/domain/servico/ArquivoConteudo' : `${window.location.origin}/api/api/domain/servico/ArquivoConteudo` 
            }}
            onCreateFolder={(nome:string, parentFolder?:File) => {
                console.log("onCreateFolder: ", nome, parentFolder);
                mutate({
                    name : nome,
                    path : (parentFolder?.path ?? '/') + nome,
                    isDirectory : true
                } as ArquivoConteudo);
            }}
            onDelete={(file:File[]) => {
                console.log("onDelete", file);

                mutateDeletar(file);
            }}
            onDownload={(files:File[]) => {
                console.log("onDownload", files);
                for (const file of files) {
                    mutateBaixar(file);
                }
            }}
            onFileOpen={(file:File) => {
                console.log("onFileOpen", file);

                if (file.isDirectory) setCaminho(file.path);
                else onChange(file);
            }}
            onFolderChange={(path: string) => {
                console.log("onFolderChange", path);
            }}
            onFileUploading={(_:File, parentFolder?: File) => {
                if (parentFolder !== undefined)
                    return {
                        "parente.nome" : parentFolder.name,
                        "parente.caminho" : parentFolder.path,
                        "parente.isDiretorio" : parentFolder.isDirectory,
                        "parente.tamanho" : parentFolder.size
                        //,
                        // "parente.dataAtualizacao" : parentFolder.updatedAt
                    }

                return [];
            }}
            onFileUploaded={(file:File) => {
                console.log("onFileUploaded", file);

                refetch();
            }}
            onRefresh={() => {
                refetch();
            }}
            onRename={(file: File, newName: string) => {
                console.log("onRename", file, newName);
                mutateRenomear({
                    atual : file,
                    novo : newName
                });
            }}
            permissions={{
                create: true,
                delete: true,
                download: true,
                rename: true,
                upload: true,
                copy: false,
                move: false
            }}
        />
    </div>;
}

type File = ArquivoConteudo & {
};
